



















import {Component, Prop, Vue} from "vue-property-decorator";
import Cta from "@/components/cta.vue";

@Component({
    components: {Cta}
}) export default class extends Vue {
    @Prop() data;

    mounted() {
        
    }

    close() {
        this.$eventEmitter.emit('closePopup');
    }
}
